import moment from "moment";

export const canBeDeleted = (productId: string, timestamp: number) => {
  const days = moment().diff(timestamp, "days");
  return productId === "platform" && days < 2;
};
